import React, { useEffect, useState } from "react";
import { authService } from "../services/auth.service";
import { userService } from "../services/user.service";
import { useNavigate } from "react-router-dom";

const AuthStateContext = React.createContext();
const AuthDispatchContext = React.createContext();


function reducer(currentState, newState) {
  return { ...currentState, ...newState };
}

function useAuthState() {
  const context = React.useContext(AuthStateContext);
  if (!context) throw new Error("useAuthState must be used in AuthProvider");
  return context;
}

function useAuthDispatch() {
  const context = React.useContext(AuthDispatchContext);
  if (!context) throw new Error("useAuthDispatch must be used in AuthProvider");
  return context;
}

const initialState = {
  status: "idle",
  user: null,
  error: null
};

const getUserInfo = async() => {
  const res = await userService.isUserLoggedIn();
  return res;
}

function AuthProvider(props) {
  console.log("authprovider");
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUserInfo().then((res) => {
      if (res.status === 200){
        dispatch({
          status: "resolved",
          user: res.data.user,
          error: null
        });

      }
      setLoading(false);
    })
  }, [])

  if (loading) return;

  return (
    <AuthStateContext.Provider value={state}>
      <AuthDispatchContext.Provider value={dispatch}>
        {props.children}
      </AuthDispatchContext.Provider>
    </AuthStateContext.Provider>
  );
}

async function doLogin(dispatch, email, password) {
  try {
    dispatch({ status: "pending" });

    const result = await authService.loginUser(email, password);
    if (result.status === 200){
      const userInfo = await userService.isUserLoggedIn();
      dispatch({
        status: "resolved",
        user: userInfo.data.user,
        error: null
      });

    } else if(result.status === 400){
      dispatch({
        status: "rejected",
        user: null,
        error: result.data.details[0].details
      });
    } else if(result.status === 401){
      dispatch({
        status: "rejected",
        user: null,
        error: result.data.error
      });
    } else if(result.status === 403){
      dispatch({
        status: "rejected",
        user: null,
        error: "Invalid Captcha"
      });
    } else {
      dispatch({
        status: "rejected",
        user: null,
        error: "Unknown error during login"
      });
    }
  } catch (error) {
    dispatch({ status: "rejected", error });
  }
}

async function doLogout(dispatch) {
  await userService.logout();
  dispatch(initialState);
}

async function doRefreshUser(dispatch) {
  console.log("doRefreshUser");
  const userInfo = await userService.isUserLoggedIn();
  dispatch({
    status: "resolved",
    user: userInfo.data.user,
    error: null
  });
}


export { AuthProvider, useAuthState, useAuthDispatch, doLogin, doLogout, doRefreshUser };
